export default function Main({ children }) {
  return <main className="container mx-auto p-4">{children}</main>;
}
